import { Component } from '../../scripts/component';
import { debounce } from '../../scripts/utils';
if (!customElements.get('header-menu')) {
  /**
   * A custom element that manages the main menu drawer.
   *
   * @typedef {object} Refs
   *
   * @extends {Component<Refs>}
   */
  class HeaderMenu extends Component {
    // Debounce on hover
    connectedCallback() {
      super.connectedCallback();
      this.debouncedOnLinkHover = debounce(this.onLinkHover, 0);
      this.debouncedOnMouseLeave = debounce(this.onMouseLeave, 0);

      this.genderMenuItems.forEach((link) => {
        link.addEventListener('mouseenter', this.debouncedOnLinkHover);
        link.addEventListener('mouseleave', this.debouncedOnMouseLeave);
      });
    }

    disconnectedCallback() {
      this.genderMenuItems.forEach((link) => {
        link.removeEventListener('mouseenter', this.debouncedOnLinkHover);
        link.removeEventListener('mouseleave', this.debouncedOnMouseLeave);
      });
    }

    get genderMenuItems() {
      return this.querySelectorAll('[header-menu-link]');
    }

    onLinkHover(event) {
      const input = event.target.querySelector('input[type="radio"]');
      if (input) input.checked = true;
    }

    onMouseLeave(event) {
      const input = event.target.querySelector('input[type="radio"]');
      if (input) input.checked = false;
    }
  }
  customElements.define('header-menu', HeaderMenu);
}
